/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useState } from 'react';
import * as gtag from '../../lib/gtag';
import * as commonLandingStyles from './landingpage.styles';
import * as styles from './inspiration.styles';
import { Inspiration as InspirationIllustration } from './illustrations/all';

interface InspirationClickEventHandler {
  (ideaToExpand: number): void;
}

interface InspirationIdeaProps {
  itemNumber: number;
  activeItem: number;
  onClick: InspirationClickEventHandler;
}

const InspirationIdea: FC<InspirationIdeaProps> = ({
  itemNumber,
  activeItem,
  onClick,
  children,
}) => {
  const isActive = itemNumber === activeItem;
  const nextItem = itemNumber + 1;
  return (
    <li
      css={styles.ideaListItem(isActive, itemNumber)}
      onClick={(eventData) => {
        eventData.stopPropagation();
        onClick(itemNumber);
        return false;
      }}
    >
      <div
        css={styles.ideaContent(isActive)}
        onClick={(eventData) => {
          eventData.stopPropagation();
          onClick(nextItem);
          return false;
        }}
      >
        {children}
      </div>
    </li>
  );
};

const Inspiration: React.FC = () => {
  const totalIdeaCount = 3; // update this to ensure transitions work
  const [expandedIdea, setExpandedIdea] = useState(1);

  const toggleExpandedIdea = (ideaToExpand: number) => {
    let expand = ideaToExpand;
    if (expand < 1 || expand > totalIdeaCount) {
      expand = 1;
    }
    gtag.event({
      category: 'landing-page',
      action: 'click',
      label: 'inspiration-idea',
      value: expand,
    });
    setExpandedIdea(expand);
  };

  return (
    <div css={styles.container}>
      <div css={commonLandingStyles.sectionContainer}>
        <div css={styles.inspirationGrid}>
          <span css={styles.inspirationHeaderGrid}>
            <h2 css={commonLandingStyles.sectionHeader}>Need inspiration?</h2>
          </span>
          <span css={styles.inspirationListGrid}>
            <ol css={styles.ideaList}>
              <InspirationIdea
                itemNumber={1}
                activeItem={expandedIdea}
                onClick={toggleExpandedIdea}
              >
                <strong>Empowered Agencies</strong>
                <p>
                  Agencies are using Domain APIs to inspire confidence in buyers
                  and sellers, by displaying the latest property data on their
                  reports, apps and websites.
                </p>
              </InspirationIdea>
              <InspirationIdea
                itemNumber={2}
                activeItem={expandedIdea}
                onClick={toggleExpandedIdea}
              >
                <strong>CRM Listing Uploads &amp; Lead Management</strong>
                <p>
                  Agencies and CRMs also use our APIs to track marketing
                  performance, enquiries and manage the complete lifecycle of
                  their listings.
                </p>
              </InspirationIdea>
              <InspirationIdea
                itemNumber={3}
                activeItem={expandedIdea}
                onClick={toggleExpandedIdea}
              >
                <strong>Banking &amp; Finance</strong>
                <p>
                  Banks and Fintechs use Domain APIs to estimate property
                  equity, understand suburb performance, median house prices and
                  demographics.
                </p>
              </InspirationIdea>
            </ol>
          </span>
          <span css={styles.inspirationImageGrid}>
            <div>
              <InspirationIllustration />
            </div>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Inspiration;
